import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { STORAGE_KEYS_CONSTANTS } from '@core/constants';
import { Consent, Language, Storage } from '@core/services';
import { TranslateService } from '@ngx-translate/core';
import { LanguageUtil } from '@shared/utils';
import { CookieBanner } from '@shared/components';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CookieBanner],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly translate = inject(TranslateService);
  private readonly storage = inject(Storage);
  private readonly language = inject(Language);
  private readonly consent = inject(Consent);

  title = 'inmersion-frontend-2026';

  constructor() {
    // Reaplica la decisión de consentimiento previa para Google Consent Mode.
    this.consent.applyStoredConsent();

    this.translate.addLangs(['es', 'en']);

    if (this.storage.isLocal(STORAGE_KEYS_CONSTANTS.LANGUAGE)) {
      const lang = this.storage.getLocal(STORAGE_KEYS_CONSTANTS.LANGUAGE);
      this.translate.setFallbackLang(lang);
      this.language.setActualLanguage(lang);
    } else {
      this.storage.setLocal(STORAGE_KEYS_CONSTANTS.LANGUAGE, 'es');
      this.translate.setFallbackLang('es');
      this.language.setActualLanguage('es');
    }

    /** Use el lenguaje seleccionado */
    this.setLanguage();
  }

  /** Función que envia el lenguaje a utilizar */
  setLanguage(): void {
    if (LanguageUtil.getStorageLanguage()) {
      this.translate.use(LanguageUtil.getStorageLanguage());
    } else {
      this.translate.use(this.translate.getBrowserLang() as string);
    }
  }
}
